import script from "./Krediflow-Settings-Bexio.vue?vue&type=script&setup=true&lang=js"
export * from "./Krediflow-Settings-Bexio.vue?vue&type=script&setup=true&lang=js"

import "./Krediflow-Settings-Bexio.vue?vue&type=style&index=0&id=cbfb46b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbfb46b0"]])

export default __exports__